import { LitElement, html, css } from 'lit-element';
import { connect } from '../store/connect';
import { actions } from './';
import { actions as userActions, selectors as userSelectors } from '../user';
import { actions as notificationActions } from '../notification';

import '@trumedianetworks/tmn-core-components/src/tmn-button';
import '@trumedianetworks/tmn-core-components/src/tmn-grid';
import '@trumedianetworks/tmn-core-components/src/tmn-input';
//import '../routing/routed-button';

class AccountLogin extends LitElement {
    constructor() {
        super();
    }

    static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex: 1;
                    flex-flow: column;
                    max-width: 600px;
                    min-width: 365px;
                }
                :host([hidden]) {
                    display: none;
                }
                tmn-button[variant='contained'] {
                    width: 100%;
                    max-width: 225px;
                }

                .logo {
                    height: 120px;
                }
                tmn-input {
                    width: 100%;
                }
                .app-name {
                    font-size: 1.2rem;
                    color: var(--app-primary-dark-color);
                }
                .site-missing {
                    font-weight: 600;
                    margin-left: 10px;
                    color: var(--app-error-color);
                }
            `,
        ];
    }

    static get properties() {
        return {
            username: {
                type: String,
            },
            password: {
                type: String,
            },
            authSite: {
                type: String,
            },
            showAuthInput: {
                type: Boolean,
            },
            showAuthSiteMessage: {
                type: Boolean,
            },
        };
    }
    updated(changedProps) {
        if (changedProps.has('authSite')) {
            if (!this.authSite) {
                this.showAuthInput = true;
            }
            if (this.authSite) {
                this.showAuthSiteMessage = false;
            }
        }
    }

    render() {
        const { username = '', password = '' } = this;
        //const pwResetData = { username, authSite };
        ///const pwResetRouteName = authSite ? 'reset-password-site' : 'reset-password';
        return html`
            <tmn-grid
                container
                direction="column"
                justify="center"
                alignContent="center"
                spacing="2"
                @keydown=${this.handleEnter}>
                <tmn-grid item container justify="center">${this.renderLogo()}</tmn-grid>
                <tmn-grid item container justify="center"
                    ><span class="app-name">Admin Console</span></tmn-grid
                >
                <tmn-grid item>
                    <tmn-input
                        @tmn-input-changed=${this.handleInputChanged}
                        placeholder="username"
                        name="username"
                        inputName="username"
                        type="text"
                        required
                        .value=${username}>
                    </tmn-input>
                </tmn-grid>
                <tmn-grid item>
                    <tmn-input
                        @tmn-input-changed=${this.handleInputChanged}
                        placeholder="password"
                        required
                        name="password"
                        inputName="password"
                        type="password"
                        .value=${password}>
                    </tmn-input>
                </tmn-grid>
                <tmn-grid item container alignItems="flex-start" direction="column"
                    >${this.renderAuthSite()}</tmn-grid
                >
                <tmn-grid item>
                    <tmn-button color="primary" variant="link" @click=${this.handleForgotPassword}
                        >forgot password</tmn-button
                    >
                </tmn-grid>
                <tmn-grid item>
                    <tmn-button color="primary" variant="contained" @click=${this.handleLogin}
                        >Sign In</tmn-button
                    >
                </tmn-grid>
            </tmn-grid>
        `;
    }

    renderAuthSite() {
        const { authSite = '', showAuthInput, showAuthSiteMessage } = this;
        if (authSite && !showAuthInput) {
            return html`<tmn-button
                color="primary"
                variant="link"
                @click=${this.toggleShowAuthInput}
                >${authSite}</tmn-button
            >`;
            //return html`<a href="#" @click=${this.toggleShowAuthInput}>${authSite}</a>`;
        }
        return html`<tmn-input
                @tmn-input-changed=${this.handleAuthSiteChanged}
                @tmn-input-blur=${this.handleAuthSiteBlur}
                placeholder="sitename"
                required
                name="authSite"
                .value=${authSite}>
            </tmn-input
            >${showAuthSiteMessage
                ? html`<div class="site-missing">please enter sitename</div>`
                : null}`;
    }

    toggleShowAuthInput(e) {
        e.preventDefault();
        this.showAuthInput = !this.showAuthInput;
        return false;
    }

    renderLogo() {
        return html`<img
            src="/assets/images/trumedia_networks.svg"
            alt="TruMedia Networks"
            class="logo" />`;
    }

    handleInputChanged(e) {
        const { target, detail } = e;
        this[target.name] = detail.value;
    }

    handleAuthSiteChanged(e) {
        const { target, detail } = e;
        const authSite = detail.value;
        this.actions.setActiveAuthSite({ activeAuthSite: authSite });
    }

    handleAuthSiteBlur(e) {
        const { target, detail } = e;
        const authSite = detail.value;
        if (authSite) {
            this.showAuthInput = false;
        }
    }

    handleEnter(e) {
        if (e.key === 'Enter') {
            this.handleLogin(e);
        }
    }

    handleLogin(e) {
        const { username = '', password = '', authSite } = this;
        if (!(username && password)) {
            this.actions.showSnackbar({
                snackbarMessage: `Username and password are required.`,
                snackbarType: 'error',
            });
            return;
        }
        this.actions.setActiveAuthSite({ activeAuthSite: authSite });
        this.actions.login(username, password, authSite);
    }

    handleForgotPassword(e) {
        const { authSite } = this;
        if (!authSite) {
            this.showAuthSiteMessage = true;
            return;
        }
        this.actions.setActiveAuthSite({ activeAuthSite: authSite });
        this.actions.navigateResetPassword({ authSite });
    }
}

const mapStateToProps = (state, ownProps) => {
    return (state) => {
        return {
            authSite: userSelectors.activeAuthSiteNameSelector(state),
        };
    };
};

const combinedActions = {
    ...actions,
    ...userActions,
    ...notificationActions,
};

customElements.define('account-login', connect(mapStateToProps, combinedActions)(AccountLogin));
